import { Project } from "../../../types";
import { useQuery } from "@tanstack/react-query";
import { getProjectsApi } from "../../../api/resources.api";

export const useSingleProject = (id?: number) => {
  return useQuery<Project, Error>({
    queryKey: ["project", id],
    enabled: !!id,

    queryFn: async () => {
      const response = await getProjectsApi({ id });
      if (!response?.status || !Array.isArray(response.data)) {
        throw new Error("Invalid Project data format");
      }

      const project = response.data[0];

      if (!project) {
        throw new Error("Project not found");
      }

      return project;
    },

    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
    retry: 1,
    refetchOnWindowFocus: false,
  });
};
